module.exports = __webpack_public_path__ + "img/bgr-stars.24d58b98.svg";